export const cs = {
    phone_number: "Telefonní číslo",
    pickup: "Vyzvednutí",
    required: "Údaj je povinný",
    invalid_phone_number: "Zadejte platné telefonní číslo",
    banned_phone_number:
        "Objednávky nejsou pro toto telefonní číslo povoleny. Pokud si myslíte, že se jedná o chybu, kontaktujte podporu.",
    public_link_depleted:
        "Tento odkaz dosáhl svého limitu použití. Další objednávky nejsou k dispozici.",
    public_link_not_found: "Tento odkaz není platný.",
    public_order_link_price_exceeded:
        "Cena této jízdy převyšuje maximální povolenou částku pro tento odkaz.",
    geolocation_failed: "Nepodařilo se zjistit vaši polohu. Zadejte prosím adresu ručně.",
    geolocation_permission_denied_title: "Přístup k poloze zablokován",
    geolocation_permission_denied_message:
        "Pro použití vaší aktuální polohy povolte přístup k poloze v nastavení prohlížeče.",
    geolocation_permission_denied_button: "Rozumím",
    CZK: "Kč",
    EUR: "€",
    on_board: "Ve voze",
    soon: "brzy",
    in_min_plural: "za {count} min",
    driver_not_found: "Řidič nenalezen",
    cancel_ride: "Zrušit jízdu",
    canceling: "Ruší se…",
    cancel_failed: "Zrušení selhalo",
    ride_cancelled: "Jízda zrušena",
    price_not_found: "Cena nenalezena, prosím zkuste to znovu.",
    name: "Jméno",
    destination: "Cíl",
    pickup_time_15_min: "15 min",
    generic_error: "Něco se pokazilo. Prosím zkuste to znovu později.",
    pay: "Zaplatit",
    payment_failed: "Platba se nezdařila",
    search: "Hledat…",
    delete: "Smazat",
    payment_card_bullet_1: "Platba automaticky po každé jízdě",
    payment_card_bullet_2: "Souhrnná faktura na konci měsíce",
    monthly_payment_bullet_1: "Platba převodem jednou měsíčně",
    monthly_payment_bullet_2: "Souhrnná faktura na konci měsíce",
    close: "Zavřít",
    registration_legal_info:
        "Pokračováním souhlasíte s <terms>Všeobecnými obchodními podmínkami</terms>. Osobní údaje budou zpracovávány k účelu uvedenému v <policy>Zásadách ochrany osobních údajů</policy>",
    terms_url: "https://www.liftago.cz/vseobecne-obchodni-podminky/",
    policy_url: "https://www.liftago.cz/zasady-ochrany-osobnich-udaju/",
    back: "Zpět",
    rate_the_ride: "Ohodnotit jízdu",
    // kiosk
    order_confirmed: "Objednávka vytvořena",
    sms_details:
        "Brzy obdržíte SMS s údaji o vašem řidiči a čase příjezdu. Pokud ne, kontaktujte recepci.",
    cancel_booking: "Pro zrušení rezervace zavolejte řidiči nebo recepci.",
    get_taxi: "Objednat taxi",
    no_destination_found: 'Žádná destinace nenalezena pro "{search}"',
    search_for_destination: "Vyhledejte adresu nebo místo",
    enter_contact_details: "Zadejte své kontaktní údaje",
    pickup_in: "Vyzvednutí za",
    dropoff_by: "V cíli",
    price: "Cena",
    price_with_promo: "Cena po slevě",
    confirm_order: "Potvrdit objednávku",
    visa_mastercard: "Visa, Mastercard",
    pay_to_driver: "Zaplatit řidiči",
    cash_or_card: "Hotově nebo kartou",
    payment_covered: "Jízda je pro vás plně hrazena. Řidiči neplaťte.",
    kiosk_order_failed: "Objednávka se nezdařila. Požádejte personál o pomoc nebo to zkuste znovu.",
    reviews: "hodnocení",
    enter_pickup: "Zadejte místo vyzvednutí",
    enter_destination: "Zadejte cílovou adresu",
    order_taxi_without_registration: "Objednat taxi bez registrace",
    location_input_placeholder_pickup: "Adresa vyzvednutí",
    location_input_placeholder_dropoff: "Cílová adresa",
    enter_route: "Zadejte trasu",
    ride_finished: "Jízda dokončena",
    order_cancelled: "Objednávka zrušena",
    driver_cancelled: "Řidič zrušil jízdu",
    driver_is_arriving: "Příjezd řidiče {when}",
    driver_is_waiting: "Řidič čeká na místě",
    order_not_found: "Objednávka nenalezena",
    searching_driver: "Hledáme vhodného řidiče",
    search_longer_than_usual: "Hledání trvá déle než obvykle, prosíme o trpělivost.",
    search_usual_time: "Obvykle trvá 15 sekund",
    refund_shortly: "Brzy vám vrátíme peníze.",
    email_support: "Pokud něco nebylo v pořádku, napište nám na service@liftago.com.",
    you_can_order_again: "Můžete si objednat znovu.",
    please_order_again: "Objednejte si prosím znovu.",
    no_drivers_available: "Je nám líto, ale momentálně nejsou k dispozici žádní řidiči.",
    new_order: "Nová objednávka",
    order_again: "Objednat znovu",
    driver_location_phone: "Zobrazit telefon a polohu řidiče",
    set_pickup_here: "Vyzvednutí zde",
    set_destination_here: "Cíl zde",
    pay_by_card: "Zaplatit kartou",
    no_drivers_around:
        "Bohužel se nyní ve vašem okolí nenachází žádný řidič. Zkuste to prosím za chvíli.",
    not_viable_route: "Zvolená trasa je příliš krátká. Zvolte prosím vzdálenější cíl.",
    are_you_sure_to_cancel_ride: "Opravdu chcete zrušit jízdu?",
    public_order_brand_title: "Liftago: Bezpečná jízda",
    public_order_brand_reviews: "({count} tis. recenzí)",
    public_order_brand_trust_indicator_quality_cars: "Kvalitní vozy",
    public_order_brand_trust_indicator_verified_drivers: "Prověření řidiči",
} as const;
